export default "__VITE_ASSET__cT4NE$Kr__";